import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import moment from "moment";
// import html2pdf from "html2pdf.js";

import { useParams, Link } from "react-router-dom";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import html2pdf from "html2pdf.js";
import jsPDF from "jspdf";
import JsBarcode from "jsbarcode";
import html2canvas from "html2canvas";
import { toastError, toastSuccess } from "../../../common/Toast";
import { DATA_EXPORT, ERROR_MESSAGE } from "../../../common/Constant";
import * as XLSX from "xlsx";

const ReceivingReceipt = (props) => {
  const token = localStorage.getItem("Token");
  const [formValues, setFormValues] = useState([]);
  const [responseData, setResponseData] = useState([]);
  const [supplierData, setSupplierData] = useState([]);
  console.log(supplierData, "response123667");
  const [companyData, setCompanyData] = useState([]);
  const [receive, setReceive] = useState([]);
  const [SynckCheck, setSynckCheck] = useState('');
  const [SynckMassageCheck, setSynckMassageCheck] = useState('');

  const [loading, setLoading] = useState(false);
  const [totalSum, setTotalSum] = useState(0);

  const [selectedId, setSelectedId] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const ITEMS_PER_PAGE = 20;
  const barcodeRefs = useRef([]);
  let index = 0;
  const [data, setData] = useState({
    inputValue: "",
    width: 1,
    height: 20,
    fontSize: 15,
    zeroFill: 10,
  });

  // responcedata.ReceivingItems[0].QuantityReceived

  // 

  let sumss = 0;
  for (let i = 0; i < responseData.length; i++) {
    console.log(responseData[i].QuantityReceived,"7966465468");
    
    const quantity = responseData[i].QuantityReceived
      ? Number(responseData[i].QuantityReceived)
      : 0;
    sumss += quantity;
  }

  console.log(sumss , "check sum")

  console.log(receive, "4455656");
  const generateBarcodes = () => {
    barcodeRefs.current.forEach((barcodeRef, index) => {
      console.log("barcodeRefs", barcodeRefs);
      var g = document.getElementsByTagName(barcodeRef);
      const barcodeValue = paramObject.id;
      console.log("barcodeValue", barcodeValue);
      const paddedBarcodeValue = barcodeValue?.padStart(data.zeroFill, "0");
      JsBarcode(barcodeRef, paddedBarcodeValue, {
        width: data.width,
        height: data.height,
        fontSize: data.fontSize,
        displayValue: true,
        fontoptions: "bold",
        textAlign: "center",
        font: "monospace",
        textPosition: "bottom",
        textMargin: 2,
        margin: 10,
        marginTop: undefined,
        marginBottom: undefined,
        marginLeft: undefined,
        marginRight: undefined,
        format: "CODE128",
        valid: () => true,
        background: "#ffffff",
        lineColor: "#000000",
        padding: data.zeroFill,
      });
    });
  };

  //Function for downloading pdf of barcodesheet
  const downloadPdf = () => {
    setCurrentPage(1);
    const pdf = new jsPDF();
    responseData.forEach((item) => {
      // Generate barcode for the current item
      const barcodeRef = barcodeRefs.current[item.ReceivingId];
      const barcodeValue = `${item.ReceivingId}`;
      const paddedBarcodeValue = barcodeValue.padStart(data.zeroFill, "0");
      JsBarcode(barcodeRef, paddedBarcodeValue, {
        // barcode options
      });

      // Add barcode to PDF
      const canvas = barcodeRef;
      const imgData = canvas.toDataURL("image/png");
      pdf.addImage(imgData, "PNG", 10, 10);
      pdf.addPage();
      console.log(canvas, "imgData-------------------->");
    });
    pdf.deletePage(responseData.length + 1); // Remove extra page added by addPage() method
    pdf.save("barcodes.pdf");
  };

  const handleUnSuspend = (pID) => {
    // console.log("Pid",pID);
    axios
      .get(
        `${config.receivingBaseUrl}/receivings/listofsuspendrecordByid?id=${pID}`,

        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log("res from Suspended Receiving======>", res);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  //Function for lookup receipt

  const paramObject = useParams();

  const getData = () => {
    return axios.get(
      `${config.receivingBaseUrl}/receivings/lookupreceipt?receivingid=${
        paramObject.id === undefined ? 0 : paramObject.id
      }`,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      }
    );
  };

  useEffect(() => {
    generateBarcodes();
    console.log("barcodeRefs", barcodeRefs);
    setLoading(true);
    fetchedData();
    // axios
    //   .get(
    //     `${config.receivingBaseUrl}/receivings/lookupreceipt?receivingid=${paramObject.id}`,
    //     {
    //       headers: {
    //         "Content-Type": "application/json;charset=UTF-8",
    //         "Access-Control-Allow-Origin": "*",
    //         Authorization: token,
    //       },
    //     }
    //   )
    //   .then((res) => {
    //     console.log("res564565131", res);
    //     const ItemList = res.data.ResponseData.itemList;
    //     const SupplierData = res.data.ResponseData.supplierData;
    //     const unSuspendData = res.data.ResponseData.unSuspendData;
    //     console.log("ItemList", ItemList);
    //     console.log("SupplierData", SupplierData);

    //     console.log(res.data.ResponseData);
    //     if (res.data.ResponseCode === "SUCCESS") {
    //       setResponseData(ItemList);
    //       setSupplierData(SupplierData);
    //       setReceive(unSuspendData);
    //       console.log("11", responseData);
    //       //   barcodeRefs.current = responseData;
    //     }
    //     setLoading(false);
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //     setLoading(false);
    //   });
  }, [paramObject.id]);

  const fetchedData = async () => {
    try {
      const res = await getData();
      setSynckCheck(res?.data?.ResponseData?.SyncDetail[0].SyncStatus)
      setSynckMassageCheck(res?.data?.ResponseData?.SyncDetail[0].Message)
      console.log(res?.data?.ResponseData?.SyncDetail[0], "check data")
      const ItemList = res.data.ResponseData.ReceivingItems;
      const SupplierData = res.data.ResponseData.SupplierDetails;
      const unSuspendData = res.data.ResponseData.ReceivingDetails;
      const companyData = res.data.ResponseData.CompanyDetails;

      console.log("ItemList", ItemList);
      console.log("SupplierData", SupplierData);
      console.log("companyDataissss", companyData[0].CompanyLogo);

      console.log("ressssssss 289", res.data.ResponseData);
      if (res.data.ResponseCode === "SUCCESS") {
        setResponseData(ItemList);
        setSupplierData(SupplierData);
        setReceive(unSuspendData);
        setCompanyData(companyData);
        console.log("11", responseData);
        //   barcodeRefs.current = responseData;
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };
  console.log("Receive issss", receive);

  //Function for export excel
  const handleExcelExport = () => {
    // console.log("Response Data is comingggg", responseData);
    // setLoading(true);
    // axios
    //   .post(
    //     `${config.receivingBaseUrl}/receivings/excelexport`,
    //     {
    //       receivingid: paramObject.id,
    //     },
    //     {
    //       headers: {
    //         "Content-Type": "application/json;charset=UTF-8",
    //         Authorization: token,
    //       },
    //     }
    //   )
    //   .then((res) => {
    //     console.log(res);
    //     setLoading(false);
    //   })
    //   .catch((err) => {
    //     toastError(ERROR_MESSAGE);
    //     setLoading(false);
    //   });

    const data = responseData.length > 0 ? responseData : [];

    // Create a new workbook
    const workbook = XLSX.utils.book_new();

    // Convert the data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(data);

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Save the workbook as an Excel file
    XLSX.writeFile(workbook, `customers_details_.xlsx`);
  };

  // to calculate the total
  const calculateTotalSum = () => {
    const sum = responseData.reduce((total, item) => {
      console.log("item", item);
      const itemTotal = Number(item.Total);
      console.log("itemTotal>>>>>", itemTotal);
      if (typeof itemTotal === "number" && !isNaN(itemTotal)) {
        return itemTotal;
      } else {
        return total;
      }
    }, 0);
    setTotalSum(sum);
  };
  useEffect(() => {
    calculateTotalSum();
  }, [responseData]);

  const totalPages = Math.ceil(responseData?.length / 11);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  console.log("receive 371", receive);


  const handlePrint = () => {
    let headerElement = document.querySelector("#header");
    let header1Element = document.querySelector("#header1");
    let footerElement = document.getElementById("footer");
    let TotalfooterElement = document.getElementById("Totalfooter");

    if (!headerElement || !header1Element) {
      console.error("Header or Header1 element is missing.");
      return;
    }
  
  
    const showDiscountColumn = responseData.some(item => item.DiscountPercent > 0);
  
    console.log(showDiscountColumn, "showDiscountColumn123");
  
    const itemsPerPage = 18;
    const firstPageItemsCount = 15; 
    const specialFirstPageItemsCount = 9;
    const totalItems = responseData.length;
    let carryOverSum = 0;
    let currentIndex = 1;

    // Function to split array into chunks
  // Function to split array into chunks with a different size for the first chunk
  const chunkArray = (array, specialCase) => {
    const chunks = [];
    if (specialCase) {
      if (array.length > specialFirstPageItemsCount) {
        chunks.push(array.slice(0, specialFirstPageItemsCount));
        chunks.push(array.slice(specialFirstPageItemsCount));
      } else {
        chunks.push(array);
      }
    } else {
      if (array.length > 0) {
        chunks.push(array.slice(0, firstPageItemsCount));
      }
      for (let i = firstPageItemsCount; i < array.length; i += itemsPerPage) {
        chunks.push(array.slice(i, i + itemsPerPage));
      }
    }
    return chunks;
  };

  const chunks = chunkArray(responseData, totalItems >= 7 && totalItems <= 14);

  // Create a container for the pages
  let printContainer = document.createElement("div");
  
    chunks.forEach((chunk, pageIndex) => {
      let page = document.createElement("div");
      page.style.padding = "0 20px";
      page.style.pageBreakAfter = "always";
  
      // Clone and append the appropriate header
      if (pageIndex === 0) {
        page.appendChild(headerElement.cloneNode(true)); // Header for the first page
      } else {
        page.appendChild(header1Element.cloneNode(true)); // Header for subsequent pages
      }
  
      // Create a new table for the chunk
      let table = document.createElement("table");
      table.className = "table mt-1";
      table.style.width = "100%";
      table.style.tableLayout = "fixed";
      table.style.marginBottom = "10px";
      table.style.fontSize = "5px";
      table.style.borderCollapse = "collapse";
  
      let thead = document.createElement("thead");
      thead.innerHTML = `
        <tr>
          <th style="width: 10%; background-color: #1a2649; color: #ffffff; padding: 7px;">#</th>
          <th style="width: 30%; background-color: #1a2649; color: #ffffff; padding: 7px;">Product/Services</th>
          ${showDiscountColumn ? `<th style="width: 15%; background-color: #1a2649; color: #ffffff; text-align: right; padding: 7px;">Quantity</th>` : `<th style="width: 20%; background-color: #1a2649; color: #ffffff; text-align: right; padding: 7px;">Quantity</th>`}
          ${showDiscountColumn ? `<th style="width: 15%; background-color: #1a2649; color: #ffffff; text-align: right; padding: 7px;">Price</th>` : `<th style="width: 20%; background-color: #1a2649; color: #ffffff; text-align: right; padding: 7px;">Price</th>`}
         ${
           showDiscountColumn
             ? `<th style="width: 20%; background-color: #1a2649; color: #ffffff; text-align: right; padding: 7px;">Discount %</th>`
             : ``
         }
         ${showDiscountColumn ? `<th style="width: 15%; background-color: #1a2649; color: #ffffff; text-align: right; padding: 7px;">Total</th>` : `<th style="width: 25%; background-color: #1a2649; color: #ffffff; text-align: right; padding: 7px;">Total</th>`}
        </tr>`;
  
      let tbody = document.createElement("tbody");
  
      chunk.forEach((item, index) => {
        console.log(item, "11111111111111");
        let row = document.createElement("tr");
        row.style.padding = "2px";
  
        const itemTotal = Number(item.Total);
        carryOverSum += itemTotal;
  
        row.innerHTML = `
          <td style="padding: 2px;">${currentIndex++}</td>
          <td style="text-align: left; padding: 2px;color: black;">${
            item.ItemVariationName == null
              ? item.ItemName == null
                ? '<p style="margin: 0"></p>'
                : item.ItemName
              : item.ItemVariationName
          }</td>
          <td style="text-align: right; padding: 2px;"></td>
          <td style="text-align: right; padding: 2px;"></td>
          <td style="text-align: right; padding: 2px;"></td>
          <td style="text-align: right; padding: 2px;"></td>
        `;
  
        let detailsRow = document.createElement("tr");
        detailsRow.style.padding = "2px";
        detailsRow.style.borderBottom = "0.1px solid #dcdcdc";
  
        detailsRow.innerHTML = `
          <td style="padding: 2px;"></td>
          <td style="text-align: left; padding: 2px;"></td>
          <td style="text-align: right; padding: 2px;color: black;">
            ${Number(item.QuantityReceived).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          </td>
             <td style="text-align: right; padding: 2px; color: black;">
            $ ${Number(item.ItemCostPrice).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          </td>
          ${showDiscountColumn ? (item.DiscountPercent > 0 ? `<td style="text-align: right; padding: 2px;color: black;">${Number(item.DiscountPercent).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>` : `<td></td>`) : ""}
          <td style="text-align: right; padding: 2px;color: black;">
            $ ${itemTotal.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          </td>
        `;
  
        tbody.appendChild(row);
        tbody.appendChild(detailsRow);
      });
  
      table.appendChild(thead);
      table.appendChild(tbody);
  
      let tfoot = document.createElement("tfoot");
      if (pageIndex < chunks.length - 1) {
        tfoot.innerHTML = `
         ${
           showDiscountColumn
             ? ` <tr>
               <td colspan="2" style="text-align: right; padding: 2px; margin-top: -12px;">
                Page ${pageIndex + 1} of ${chunks.length}
              </td>
                <td colspan="3" style="text-align: right; padding: 2px;"><strong>Carry Over:</strong></td>
                <td style="text-align: right; padding: 2px; color: black;">$ ${carryOverSum.toLocaleString(
                  "en-US",
                  { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                )}</td>
              </tr>`
             : ` <tr>
             <td colspan="2" style="text-align: right; padding: 2px; margin-top: -12px;">
                Page ${pageIndex + 1} of ${pageIndex + 1 == chunks.length && chunk.length > 11 ? chunks.length + 1 : chunks.length} 
            </td>
              <td colspan="2" style="text-align: right; padding: 2px;"><strong>Carry Over:</strong></td>
              <td style="text-align: right; padding: 2px; color: black;">$ ${carryOverSum.toLocaleString(
                "en-US",
                { minimumFractionDigits: 2, maximumFractionDigits: 2 }
              )}</td>
            </tr>`
         }
        `;
      } else {
        // Adding empty cells to maintain layout on the last page
        tfoot.innerHTML = `
          <tr>
            <td colspan="${showDiscountColumn ? 3 : 2}" style="text-align: right; padding: 2px; margin-top: -12px;">
              Page ${pageIndex + 1} of ${chunks.length}
            </td>
            ${
              showDiscountColumn
                ? `<td colspan="2" style="text-align: right; padding: 2px;">&nbsp;</td>
                   <td style="text-align: right; padding: 2px; color: black;">&nbsp;</td>`
                : `<td colspan="2" style="text-align: right; padding: 2px;">&nbsp;</td>
                   <td style="text-align: right; padding: 2px; color: black;">&nbsp;</td>`
            }
          </tr>
        `;
      }
      table.appendChild(tfoot);
      page.appendChild(table);

        // Append the page to the print container
        printContainer.appendChild(page);

        // Add a page break and the footer on a new page if the last chunk has more than 3 items
        // if (pageIndex === chunks.length - 1) {
        //     page.appendChild(TotalfooterElement.cloneNode(true));
        //     if (chunk.length > 11) {
        //         // Add a new page for the footer if the last chunk has more than 3 items
        //         let footerPage = document.createElement("div");
        //         footerPage.appendChild(footerElement.cloneNode(true));
        //         printContainer.appendChild(footerPage);
        //     } else {
        //         // Append footer on the same page if the last chunk has 3 or fewer items
        //         page.appendChild(footerElement.cloneNode(true));
        //     }
        // }
        if (pageIndex === chunks.length - 1) {
          page.appendChild(TotalfooterElement.cloneNode(true));
          if (chunk.length > 11) {
            // Add a new page for the footer if the last chunk has more than 7 items
            let footerPage = document.createElement("div");
            footerPage.appendChild(footerElement.cloneNode(true));
            if (pageIndex + 1 == chunks.length) {
              let tfoots = document.createElement("tfoot");
              tfoots.innerHTML = `
              <tr colspan="3" style="text-align: right; padding: 2px;> 
              <td colspan="3" style="text-align: right; padding: 2px; margin-top: -12px;">
                  <td colspan="3" style="text-align: right; padding: 2px; margin-top: -12px;"> Page ${
                    pageIndex + 2
                  } of ${chunks.length + 1} </td>   
                </td>
              </tr>
    
              `;
  
              footerPage.appendChild(tfoots);
            }
  
            printContainer.appendChild(footerPage);
          } else {
            // Append footer on the same page if the last chunk has 7 or fewer items
            page.appendChild(footerElement.cloneNode(true));
          }
        }
    });

    // Generate the PDF and open it in a new window for preview
    setTimeout(() => {
        const opt = {
            margin: 0.2,
            filename: `#${receive[0]?.Posid} - ${supplierData[0]?.CompanyName} Receiving.pdf`, //'ReceivingInvoice.pdf',
            html2canvas: { scale: 5 }, // Increase the scale for better resolution
            jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' }
        };
        html2pdf()
            .from(printContainer)
            .set(opt)
            .output('blob')  
            .then(pdfBlob => {
                const pdfUrl = URL.createObjectURL(pdfBlob);  // Create a URL for the Blob
                window.open(pdfUrl, '_blank');  // Open the PDF in a new tab
            })
            .catch(err => {
                console.error('Error generating PDF:', err);
            });
    }, 50);
};





  

  // Pdf Downaload-
  const handleDownload = () => {
    // let headerElement = document.querySelector("#header");
    // let header1Element = document.querySelector("#header1"); // New header element for subsequent pages
    // headerElement.style.marginTop = "35px";
    // headerElement.style.height = "248px";
    // headerElement.style.overflow = "hidden";
    // let footerElement = document.getElementById("footer");
    // footerElement.style.padding = "0 20px";
    // footerElement.style.marginTop = "25px";
    // let TotalfooterElement = document.getElementById("Totalfooter");
    let headerElement = document.querySelector("#header");
    let header1Element = document.querySelector("#header1");
    let footerElement = document.getElementById("footer");
    let TotalfooterElement = document.getElementById("Totalfooter");

    if (!headerElement || !header1Element) {
      console.error("Header or Header1 element is missing.");
      return;
    }
  
  
    const showDiscountColumn = responseData.some(item => item.DiscountPercent > 0);
  
    console.log(showDiscountColumn, "showDiscountColumn123");
  
    const itemsPerPage = 18;
    const firstPageItemsCount = 15; 
    const specialFirstPageItemsCount = 9;
    const totalItems = responseData.length;
    let carryOverSum = 0;
    let currentIndex = 1;

    // Function to split array into chunks
  // Function to split array into chunks with a different size for the first chunk
  const chunkArray = (array, specialCase) => {
    const chunks = [];
    if (specialCase) {
      if (array.length > specialFirstPageItemsCount) {
        chunks.push(array.slice(0, specialFirstPageItemsCount));
        chunks.push(array.slice(specialFirstPageItemsCount));
      } else {
        chunks.push(array);
      }
    } else {
      if (array.length > 0) {
        chunks.push(array.slice(0, firstPageItemsCount));
      }
      for (let i = firstPageItemsCount; i < array.length; i += itemsPerPage) {
        chunks.push(array.slice(i, i + itemsPerPage));
      }
    }
    return chunks;
  };

  const chunks = chunkArray(responseData, totalItems >= 7 && totalItems <= 14);

  // Create a container for the pages
  let printContainer = document.createElement("div");
  
    chunks.forEach((chunk, pageIndex) => {
      let page = document.createElement("div");
      page.style.padding = "0 20px";
      page.style.pageBreakAfter = "always";
  
      // Clone and append the appropriate header
      if (pageIndex === 0) {
        page.appendChild(headerElement.cloneNode(true)); // Header for the first page
      } else {
        page.appendChild(header1Element.cloneNode(true)); // Header for subsequent pages
      }
  
      // Create a new table for the chunk
      let table = document.createElement("table");
      table.className = "table mt-1";
      table.style.width = "100%";
      table.style.tableLayout = "fixed";
      table.style.marginBottom = "10px";
      table.style.fontSize = "5px";
      table.style.borderCollapse = "collapse";
  
      let thead = document.createElement("thead");
      thead.innerHTML = `
        <tr>
          <th style="width: 10%; background-color: #1a2649; color: #ffffff; padding: 7px;">#</th>
          <th style="width: 30%; background-color: #1a2649; color: #ffffff; padding: 7px;">Product/Services</th>
          ${showDiscountColumn ? `<th style="width: 15%; background-color: #1a2649; color: #ffffff; text-align: right; padding: 7px;">Quantity</th>` : `<th style="width: 20%; background-color: #1a2649; color: #ffffff; text-align: right; padding: 7px;">Quantity</th>`}
          ${showDiscountColumn ? `<th style="width: 15%; background-color: #1a2649; color: #ffffff; text-align: right; padding: 7px;">Price</th>` : `<th style="width: 20%; background-color: #1a2649; color: #ffffff; text-align: right; padding: 7px;">Price</th>`}
         ${
           showDiscountColumn
             ? `<th style="width: 20%; background-color: #1a2649; color: #ffffff; text-align: right; padding: 7px;">Discount %</th>`
             : ``
         }
         ${showDiscountColumn ? `<th style="width: 15%; background-color: #1a2649; color: #ffffff; text-align: right; padding: 7px;">Total</th>` : `<th style="width: 25%; background-color: #1a2649; color: #ffffff; text-align: right; padding: 7px;">Total</th>`}
        </tr>`;
  
      let tbody = document.createElement("tbody");
  
      chunk.forEach((item, index) => {
        console.log(item, "11111111111111");
        let row = document.createElement("tr");
        row.style.padding = "2px";
  
        const itemTotal = Number(item.Total);
        carryOverSum += itemTotal;
  
        row.innerHTML = `
          <td style="padding: 2px;">${currentIndex++}</td>
          <td style="text-align: left; padding: 2px;color: black;">${
            item.ItemVariationName == null
              ? item.ItemName == null
                ? '<p style="margin: 0"></p>'
                : item.ItemName
              : item.ItemVariationName
          }</td>
          <td style="text-align: right; padding: 2px;"></td>
          <td style="text-align: right; padding: 2px;"></td>
          <td style="text-align: right; padding: 2px;"></td>
          <td style="text-align: right; padding: 2px;"></td>
        `;
  
        let detailsRow = document.createElement("tr");
        detailsRow.style.padding = "2px";
        detailsRow.style.borderBottom = "0.1px solid #dcdcdc";
  
        detailsRow.innerHTML = `
          <td style="padding: 2px;"></td>
          <td style="text-align: left; padding: 2px;"></td>
            <td style="text-align: right; padding: 2px;color: black;">
            ${Number(item.QuantityReceived).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          </td>
          <td style="text-align: right; padding: 2px; color: black;">
            $ ${Number(item.ItemCostPrice).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          </td>
          ${showDiscountColumn ? (item.DiscountPercent > 0 ? `<td style="text-align: right; padding: 2px;color: black;">${Number(item.DiscountPercent).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>` : `<td></td>`) : ""}
          <td style="text-align: right; padding: 2px;color: black;">
            $ ${itemTotal.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          </td>
        `;
  
        tbody.appendChild(row);
        tbody.appendChild(detailsRow);
      });
  
      table.appendChild(thead);
      table.appendChild(tbody);
  
      let tfoot = document.createElement("tfoot");
      tfoot.innerHTML = `
        <tr>
          <td colspan="2" style="text-align: right; padding: 2px; margin-top: -12px;">
              Page ${pageIndex + 1} of ${pageIndex + 1 == chunks.length && chunk.length > 11 ? chunks.length + 1 : chunks.length} 
          </td>
          ${showDiscountColumn ? `<td colspan="3" style="text-align: right; padding: 2px;"><strong>CarryOver:</strong></td>` : `<td colspan="2" style="text-align: right; padding: 2px;"><strong>CarryOver:</strong></td>`}
          <td style="text-align: right; padding: 2px; color: black;">$ ${carryOverSum.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
        </tr>`;
      table.appendChild(tfoot);
      page.appendChild(table);
  
      // Append the page to the print container
      printContainer.appendChild(page);
  
      // Add a page break and the footer on a new page if the last chunk has more than 3 items
      if (pageIndex === chunks.length - 1) {
        page.appendChild(TotalfooterElement.cloneNode(true));
        if (chunk.length > 11) {
          // Add a new page for the footer if the last chunk has more than 7 items
          let footerPage = document.createElement("div");
          footerPage.appendChild(footerElement.cloneNode(true));
          if (pageIndex + 1 == chunks.length) {
            let tfoots = document.createElement("tfoot");
            tfoots.innerHTML = `
            <tr colspan="3" style="text-align: right; padding: 2px;> 
            <td colspan="3" style="text-align: right; padding: 2px; margin-top: -12px;">
                <td colspan="3" style="text-align: right; padding: 2px; margin-top: -12px;"> Page ${
                  pageIndex + 2
                } of ${chunks.length + 1} </td>   
              </td>
            </tr>
  
            `;

            footerPage.appendChild(tfoots);
          }

          printContainer.appendChild(footerPage);
        } else {
          // Append footer on the same page if the last chunk has 7 or fewer items
          page.appendChild(footerElement.cloneNode(true));
        }
      }
    });
    // setLoading(false);
    // Generate the PDF after a short delay
    setTimeout(() => {
      const opt = {
        margin: 0.2,
        filename: `#${receive[0]?.Posid} - ${supplierData[0]?.CompanyName} Receiving.pdf`, // 'ReceivingInvoice.pdf',
        html2canvas: { scale: 4 }, // Increase the scale for better resolution
        jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' }
      };
      html2pdf()
        .from(printContainer)
        .set(opt)
        .save()
        .then((pdf) => {
          console.log("PDF data exported:", pdf);
        });
    }, 50);
  };
  

// const handleDownload = () => {
//   let headerElement = document.querySelector("#header");
//   headerElement.style.marginTop = "35px";
//   headerElement.style.height = "248px";
//   headerElement.style.overflow = "hidden";
//   let footerElement = document.getElementById("footer");
//   footerElement.style.padding = "0 20px";
//   footerElement.style.marginTop = "25px";
//   let TotalfooterElement = document.getElementById("Totalfooter");

//   const showDiscountColumn = responseData.some((item) =>
//     item.DiscountPercent > 0 ? true : false
//   );

//   const itemsPerPage = 15;
//   let carryOverSum = 0;
//   let currentIndex = 1;

//   // Function to split array into chunks
//   const chunkArray = (array, chunkSize) => {
//     const chunks = [];
//     for (let i = 0; i < array.length; i += chunkSize) {
//       chunks.push(array.slice(i, i + chunkSize));
//     }
//     return chunks;
//   };

//   const chunks = chunkArray(responseData, itemsPerPage);

//   // Create a container for the PDF content
//   let printContainer = document.createElement("div");

//   chunks.forEach((chunk, pageIndex) => {
//     let page = document.createElement("div");
//     page.style.padding = "0 20px";
//     page.style.pageBreakAfter = "always";

//     // Append header only on the first page
//     if (pageIndex === 0) {
//       page.appendChild(headerElement.cloneNode(true));
//     }

//     // Create a new table for the chunk
//     let table = document.createElement("table");
//     table.className = "table mt-1";
//     table.style.width = "100%";
//     table.style.tableLayout = "fixed";
//     table.style.marginBottom = "10px";
//     table.style.fontSize = "5px";
//     table.style.borderCollapse = "collapse";

//     let thead = document.createElement("thead");
//     thead.innerHTML = `
//       <tr>
//         <th style="width: 10%; background-color: #1a2649; color: #ffffff; padding: 7px;">#</th>
//         <th style="width: 30%; background-color: #1a2649; color: #ffffff; padding: 7px;">Product/Services</th>
//         ${showDiscountColumn ? `<th style="width: 15%; background-color: #1a2649; color: #ffffff; text-align: right; padding: 7px;">Price</th>` : `<th style="width: 20%; background-color: #1a2649; color: #ffffff; text-align: right; padding: 7px;">Price</th>`}
//         ${showDiscountColumn ? `<th style="width: 15%; background-color: #1a2649; color: #ffffff; text-align: right; padding: 7px;">Quantity</th>` : `<th style="width: 20%; background-color: #1a2649; color: #ffffff; text-align: right; padding: 7px;">Quantity</th>`}
//        ${
//          showDiscountColumn
//            ? ` <th style="width: 20%; background-color: #1a2649; color: #ffffff; text-align: right; padding: 7px;">Discount %</th>`
//            : ``
//        }
//        ${showDiscountColumn ? ` <th style="width: 15%; background-color: #1a2649; color: #ffffff; text-align: right; padding: 7px;">Total</th>` : ` <th style="width: 25%; background-color: #1a2649; color: #ffffff; text-align: right; padding: 7px;">Total</th>`}
//       </tr>`;

//     let tbody = document.createElement("tbody");

//     chunk.forEach((item, index) => {
//       let row = document.createElement("tr");
//       row.style.padding = "2px";

//       const itemTotal = Number(item.Total);
//       carryOverSum += itemTotal;

//       row.innerHTML = `
//         <td style="padding: 2px;">${currentIndex++}</td>
//         <td style="text-align: left; padding: 2px;color: black;">${
//           item.ItemVariationName == null
//             ? item.ItemName == null
//               ? '<p style="margin: 0"></p>'
//               : item.ItemName
//             : item.ItemVariationName
//         }</td>
//         <td style="text-align: right; padding: 2px;"></td>
//         <td style="text-align: right; padding: 2px;"></td>
//         <td style="text-align: right; padding: 2px;"></td>
//         <td style="text-align: right; padding: 2px;"></td>
//       `;

//       let detailsRow = document.createElement("tr");
//       detailsRow.style.padding = "2px";
//       detailsRow.style.borderBottom = "0.1px solid #dcdcdc";

//       detailsRow.innerHTML = `
//         <td style="padding: 2px;"></td>
//         <td style="text-align: left; padding: 2px;"></td>
//         <td style="text-align: right; padding: 2px; color: black;">
//           $ ${Number(item.ItemCostPrice).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
//         </td>
//         <td style="text-align: right; padding: 2px;color: black;">${Number(
//           item.QuantityReceived
//         ).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
//         ${showDiscountColumn ? ((
//           item.DiscountPercent > 0
//             ? `<td style="text-align: right; padding: 2px;color: black;">${Number(
//                 item.DiscountPercent
//               ).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>`
//             : ` <td></td>`
//         )) : ""}
//         <td style="text-align: right; padding: 2px;color: black;">$ ${itemTotal.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
//       `;

//       tbody.appendChild(row);
//       tbody.appendChild(detailsRow);
//     });

//     table.appendChild(thead);
//     table.appendChild(tbody);

//     let tfoot = document.createElement("tfoot");
//     tfoot.innerHTML = `
//     ${
//      showDiscountColumn
//        ? `     <tr>
//          <td colspan="2" style="text-align: right; padding: 2px; margin-top: -12px;">
//           Page ${pageIndex + 1} of ${chunks.length}
//         </td>
//           <td colspan="3" style="text-align: right; padding: 2px;"><strong>CarryOver:</strong></td>
//           <td style="text-align: right; padding: 2px; color: black;">$ ${carryOverSum.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
//         </tr>`
//        : `     <tr>
//          <td colspan="2" style="text-align: right; padding: 2px; margin-top: -12px;">
//           Page ${pageIndex + 1} of ${chunks.length}
//         </td>
//           <td colspan="2" style="text-align: right; padding: 2px;"><strong>CarryOver:</strong></td>
//           <td style="text-align: right; padding: 2px; color: black;">$ ${carryOverSum.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
//         </tr>`
//    }
//     `;
//     table.appendChild(tfoot);
//     page.appendChild(table);

//     printContainer.appendChild(page);

//     // Append footer logic
//     if (pageIndex === chunks.length - 1) {
//       page.appendChild(TotalfooterElement.cloneNode(true));
//       if (chunk.length > 7) {
//         let footerPage = document.createElement("div");
//         footerPage.appendChild(footerElement.cloneNode(true));
//         printContainer.appendChild(footerPage);
//       } else {
//         page.appendChild(footerElement.cloneNode(true));
//       }
//     }
//   });

//   setLoading(false);
//   setTimeout(() => {
//     html2pdf()
//       .from(printContainer)
//       .save("dataurlnewwindow")
//       .then((pdf) => {
//         console.log("PDF data exported:", pdf);
//       });
//   }, 50);
// };


  //   const handleDownload = () => {
  //     var doc = new jsPDF("p", "pt", "a4");
  //     let imageUrl = companyData[0]?.CompanyLogo
  //     console.log(imageUrl , "imageUrl-->")
  //     // Add the image to the top left side
  //     var img = new Image();
  //     img.src = imageUrl;
  //     img.onload = function() {
  //         doc.addImage(img, 'PNG', 20, 20, 60, 60);

  //         // Add the header
  //         let headerElement = document.querySelector("#header");
  //         let clonedHeader = headerElement.cloneNode(true);
  //         clonedHeader.style.fontSize = `7px`;
  //         clonedHeader.style.width = "600px";
  //         clonedHeader.style.height = "320px";
  //         clonedHeader.style.marginTop = "50px";
  //         clonedHeader.style.overflow = "hidden";

  //         let content = "<html><body>";
  //         content +=
  //           "<style>#header p{ font-size : 10px !important;} div{ font-size : 10px !important;}</style>";

  //         let startIndex = 1;
  //         let endIndex = 10;
  //         let carryOverSum = 0;

  //         console.log("page-no 396", document.getElementById("page-no").innerText);

  //         for (var i = 1; i <= Math.ceil(responseData.length / 10); i++) {
  //             // Printing page no-
  //             let pageNoElement = clonedHeader.querySelector("#page-no");
  //             pageNoElement.innerText = i + "/" + totalPages;

  //             // Printing header-
  //             content += clonedHeader.outerHTML;
  //             // Printing table body-
  //             content +=
  //               '<table style="font-size: 7px; margin-left: 25px; margin-Right: 50px;margin-bottom: 15px; width: 560px; border: 1px solid #f5f5f5">';
  //             content +=
  //               "<thead><tr style='margin-bottom: 5px;background-color: #1a2649; color:#ffffff;font-size: 12px;font-family: Inter, sans-serif'>" +
  //               '<th style=" margin-left: 10px;padding: 5px;background-color: #1a2649; color:#ffffff;font-size: 10px;font-family: Inter, sans-serif">#</th>' +
  //               '<th style="padding: 5px;background-color: #1a2649; color:#ffffff;font-size: 10px;font-family: Inter, sans-serif; width: 300px">Product/Services</th>' +
  //               '<th style="padding: 5px;background-color: #1a2649; color:#ffffff;font-size: 10px;font-family: Inter, sans-serif">Price</th>' +
  //               '<th style="padding: 5px;background-color: #1a2649; color:#ffffff;font-size: 10px;font-family: Inter, sans-serif">Quantity</th>' +
  //               '<th style="padding: 5px;background-color: #1a2649; color:#ffffff;font-size: 10px;font-family: Inter, sans-serif">Discount%</th>' +
  //               '<th style="padding: 5px;background-color: #1a2649; color:#ffffff;font-size: 10px;font-family: Inter, sans-serif">Total</th>' +
  //               "</tr></thead>";
  //             content += "<tbody>";

  //             // Loop for printing items based on endIndex-
  //             for (let index = startIndex; index <= endIndex; index++) {
  //                 if (index >= startIndex && index <= responseData.length) {
  //                     content += '<tr style="">';
  //                     content +=
  //                       ' <td  style="padding-top:5px;padding-left: 10px;font-size: 7px ">' +
  //                       index +
  //                       "</td>";
  //                     content +=
  //                       ' <td colspan="6" style="font-size: 5px;padding-left:5px;text-align: left; font-family: Inter, sans-serif">' +
  //                       '<p style="font-size: 8px;padding-top:7px; font-family: Inter, sans-serif;margin: 0 ; ">' +
  //                       (responseData[index - 1].ItemName == null
  //                         ? '<p  style="  margin: 0"></p>'
  //                         : responseData[index - 1].ItemName) +
  //                       (responseData[index - 1].ItemVariationName == null
  //                         ? '<p  style="  margin: 0"></p>'
  //                         : responseData[index - 1].ItemVariationName) +
  //                       "</p>" +
  //                       "</td>";
  //                     content += "</tr>";
  //                     content +=
  //                       '<tr style="border-bottom: 0.5px solid  #f2f2f2; padding-top: 5px">';

  //                     content += ' <td  style="font-size: 7px ">' + "</td>";
  //                     content +=
  //                       ' <td  style=" font-size: 8px;padding-left:5px;padding-bottom:7px; font-family: Inter, sans-serif">' +
  //                       (responseData[index - 1].Itemnumber == null
  //                         ? '<p  style=" margin: 0"></p>'
  //                         : '<p  style="font-size: 7px; font-family: Inter, sans-serif;margin: 0">' +
  //                           responseData[index - 1].Itemnumber +
  //                           "</p>") +
  //                       "</td>";

  //                     content +=
  //                       ' <td style=" padding-left:5px;font-size: 8px; padding-bottom:7px; font-family: Inter, sans-serif;">' +
  //                       Number(responseData[index - 1].ItemCostPrice).toFixed(2) +
  //                       "</td>";
  //                     content +=
  //                       ' <td style=" padding-left:5px;font-size: 8px;  font-family: Inter,sans-serif;word-wrap: break-word;">' +
  //                       Number(responseData[index - 1].QuantityReceived).toFixed(2) +
  //                       "</td>";
  //                     content +=
  //                       ' <td style="padding-left:5px; font-size: 8px; font-family: Inter,sans-serif;word-wrap: break-word;">' +
  //                       Number(responseData[index - 1].DiscountPercent).toFixed(2) +
  //                       "</td>";
  //                     content +=
  //                       ' <td style="padding-left:5px;font-size: 8px;  font-family: Inter,sans-serif;word-wrap: break-word;">' +
  //                       Number(responseData[index - 1].Total).toFixed(2) +
  //                       "</td>";

  //                     content += "</tr>";

  //                     // Add the "Total" value to the carryOverSum on each page
  //                     carryOverSum += Number(responseData[index - 1].Total);
  //                 }

  //                 if (index % 10 === 0) {
  //                     startIndex = startIndex + 10;
  //                     endIndex = endIndex + 10;
  //                     break;
  //                 }
  //             }

  //             // Printing Total or Carry Sum condition based-
  //             if (i !== Math.ceil(responseData.length / 10)) {
  //                 content +=
  //                   '<tr ><td colspan="7" style="text-align: right;padding-top:8px;padding-bottom:20px;padding-right: 10px; font-weight: bold;">Carry Over: ' +
  //                   carryOverSum.toFixed(2) +
  //                   "</td></tr>";
  //                 content += "<tr></tr>";
  //             } else {
  //                 content +=
  //                   '<tr><td colspan="7" style="text-align: right;padding-left: 10px; padding-top: 1rem; padding-bottom: 0.2rem; font-size: 10px; font-family: Inter, sans-serif">Sub Total: ' +
  //                   Number(receive[0]?.Subtotal).toFixed(2) +
  //                   "</td></tr>";

  //                 content +=
  //                   '<tr><td colspan="7" style="text-align: right;padding-left: 10px;font-weight: bold;  font-size: 10px;font-family: Inter, sans-serif">Discount: $' +
  //                   Number(receive[0]?.DiscountEntireSale).toFixed(2) +
  //                   "</td></tr>";

  //                 content +=
  //                   '<tr><td colspan="7"  style="text-align: right;font-weight: bold;padding-left: 10px; font-size: 10px;font-family: Inter, sans-serif">Total: $' +
  //                   Number(receive[0]?.Total).toFixed(2) +
  //                   "</td></tr>";
  //             }

  //             content += "</tbody>";
  //             content += "</table>";
  //         }

  //         content += "</body></html>";

  //         // Printing page-
  //         doc.html(content, {
  //           callback: function (pdf) {
  //               pdf.save("receiving.pdf");
  //           },
  //         });
  //     };
  // };

  function addContentToPDF(doc) {
    // Add the header
    let headerElement = document.querySelector("#header");
    let clonedHeader = headerElement.cloneNode(true);
    clonedHeader.style.fontSize = `7px`;
    clonedHeader.style.width = "600px";
    clonedHeader.style.height = "320px";
    clonedHeader.style.marginTop = "50px";
    clonedHeader.style.overflow = "hidden";

    let content = "<html><body>";
    content +=
      "<style>#header p{ font-size : 10px !important;} div{ font-size : 10px !important;}</style>";

    let startIndex = 1;
    let endIndex = 10;
    let carryOverSum = 0;

    for (var i = 1; i <= Math.ceil(responseData.length / 10); i++) {
      // Printing page no-
      let pageNoElement = clonedHeader.querySelector("#page-no");
      pageNoElement.innerText = i + "/" + totalPages;

      // Printing header-
      content += clonedHeader.outerHTML;
      // Printing table body-
      content +=
        '<table style="font-size: 7px; margin-left: 25px; margin-right: 50px;margin-bottom: 15px; width: 560px; border: 1px solid #f5f5f5">';
      content +=
        "<thead><tr style='margin-bottom: 5px;background-color: #1a2649; color:#ffffff;font-size: 12px;font-family: Inter, sans-serif'>" +
        '<th style="margin-left: 10px;padding: 5px;background-color: #1a2649; color:#ffffff;font-size: 10px;font-family: Inter, sans-serif">#</th>' +
        '<th style="padding: 5px;background-color: #1a2649; color:#ffffff;font-size: 10px;font-family: Inter, sans-serif; width: 300px">Product/Services</th>' +
        '<th style="padding: 5px;background-color: #1a2649; color:#ffffff;font-size: 10px;font-family: Inter, sans-serif">Price</th>' +
        '<th style="padding: 5px;background-color: #1a2649; color:#ffffff;font-size: 10px;font-family: Inter, sans-serif">Quantity</th>' +
        '<th style="padding: 5px;background-color: #1a2649; color:#ffffff;font-size: 10px;font-family: Inter, sans-serif">Discount%</th>' +
        '<th style="padding: 5px;background-color: #1a2649; color:#ffffff;font-size: 10px;font-family: Inter, sans-serif">Total</th>' +
        "</tr></thead>";
      content += "<tbody>";

      // Loop for printing items based on endIndex-
      for (let index = startIndex; index <= endIndex; index++) {
        if (index >= startIndex && index <= responseData.length) {
          content += "<tr>";
          content +=
            ' <td style="padding-top:5px;padding-left: 10px;font-size: 7px ">' +
            index +
            "</td>";
          content +=
            ' <td colspan="6" style="font-size: 5px;padding-left:5px;text-align: left; font-family: Inter, sans-serif">' +
            '<p style="font-size: 8px;padding-top:7px; font-family: Inter, sans-serif;margin: 0;">' +
            (responseData[index - 1].ItemName == null
              ? '<p style="margin: 0;"></p>'
              : responseData[index - 1].ItemName) +
            (responseData[index - 1].ItemVariationName == null
              ? '<p style="margin: 0;"></p>'
              : responseData[index - 1].ItemVariationName) +
            "</p>" +
            "</td>";
          content += "</tr>";
          content +=
            '<tr style="border-bottom: 0.5px solid  #f2f2f2; padding-top: 5px">';

          content += ' <td style="font-size: 7px;"></td>';
          content +=
            ' <td style="font-size: 8px;padding-left:5px;padding-bottom:7px; font-family: Inter, sans-serif">' +
            (responseData[index - 1].Itemnumber == null
              ? '<p style="margin: 0;"></p>'
              : '<p style="font-size: 7px; font-family: Inter, sans-serif;margin: 0;">' +
                responseData[index - 1].Itemnumber +
                "</p>") +
            "</td>";

          content +=
            ' <td style="padding-left:5px;font-size: 8px; padding-bottom:7px; font-family: Inter, sans-serif;">' +
            Number(responseData[index - 1].ItemCostPrice).toFixed(2) +
            "</td>";
          content +=
            ' <td style="padding-left:5px;font-size: 8px; font-family: Inter,sans-serif;word-wrap: break-word;">' +
            Number(responseData[index - 1].QuantityReceived).toFixed(2) +
            "</td>";
          content +=
            ' <td style="padding-left:5px;font-size: 8px; font-family: Inter,sans-serif;word-wrap: break-word;">' +
            Number(responseData[index - 1].DiscountPercent).toFixed(2) +
            "</td>";
          content +=
            ' <td style="padding-left:5px;font-size: 8px; font-family: Inter,sans-serif;word-wrap: break-word;">' +
            Number(responseData[index - 1].Total).toFixed(2) +
            "</td>";

          content += "</tr>";

          // Add the "Total" value to the carryOverSum on each page
          carryOverSum += Number(responseData[index - 1].Total);
        }

        if (index % 10 === 0) {
          startIndex = startIndex + 10;
          endIndex = endIndex + 10;
          break;
        }
      }

      // Printing Total or Carry Sum condition based-
      if (i !== Math.ceil(responseData.length / 10)) {
        content +=
          '<tr><td colspan="7" style="text-align: right;padding-top:8px;padding-bottom:20px;padding-right: 10px; font-weight: bold;">Carry Over: ' +
          carryOverSum.toFixed(2) +
          "</td></tr>";
        content += "<tr></tr>";
      } else {
        content +=
          '<tr><td colspan="7" style="text-align: right;padding-left: 10px; padding-top: 1rem; padding-bottom: 0.2rem; font-size: 10px; font-family: Inter, sans-serif">Sub Total: ' +
          Number(receive[0]?.Subtotal).toFixed(2) +
          "</td></tr>";

        content +=
          '<tr><td colspan="7" style="text-align: right;padding-left: 10px;font-weight: bold; font-size: 10px;font-family: Inter, sans-serif">Discount: $' +
          Number(receive[0]?.DiscountEntireSale).toFixed(2) +
          "</td></tr>";

        content +=
          '<tr><td colspan="7" style="text-align: right;font-weight: bold;padding-left: 10px; font-size: 10px;font-family: Inter, sans-serif">Total: $' +
          Number(receive[0]?.Total).toFixed(2) +
          "</td></tr>";
      }

      content += "</tbody>";
      content += "</table>";
    }

    content += "</body></html>";

    // Printing page-
    doc.html(content, {
      callback: function (pdf) {
        pdf.save("receiving.pdf");
      },
    });
  }

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              {/* <h3 className="page-title">Receivings Receipt</h3> */}
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/receiving">Receiving List</Link>
                </li>
                <li className="breadcrumb-item active">Receivings Receipt</li>
              </ul>
            </div>
          </div>
          <Link
            className="btn btn-sm btn-secondary me-1 mb-5"
            to={
              receive[0]?.ReceivingTypeId === 7
                ? `/Expense/${responseData[0]?.ReceivingId}`
                : `/manage-receiving/${responseData[0]?.ReceivingId}`
            }
            // to={`/manage-receiving/${responseData[0]?.ReceivingId}`}
            // onClick={handleUnSuspend(responseData[0]?.ReceivingId)}
          >
            Edit
          </Link>
          <Link
            className="btn btn-sm btn-secondary me-1 mb-5"
            to={`/receiving-barcode-label/${responseData[0]?.ReceivingId}`}
          >
            Barcode Labels
          </Link>
          <Link
            className="btn btn-sm btn-secondary me-1 mb-5"
            onClick={downloadPdf}
          >
            Barcode Sheet
          </Link>
          <Link
            className="btn btn-sm btn-secondary me-1 mb-5"
            onClick={handleExcelExport}
          >
            Excel Export
          </Link>
          <Link
            className="btn btn-sm btn-secondary me-1 mb-5"
            to={`/manage-receiving`}
            // onClick={handleUnSuspend(responseData[0]?.ReceivingId)}
            onClick={() =>
              localStorage.setItem("Clone", responseData[0]?.ReceivingId)
            }
          >
            Clone
          </Link>
          <Link
            className="btn btn-sm btn-secondary me-1 mb-5"
            onClick={handlePrint}
          >
            Print
          </Link>
          <Link
            className="btn btn-sm btn-secondary me-1 mb-5"
            onClick={handleDownload}
          >
            Download
          </Link>

             <Link className="btn btn-sm btn-secondary me-1 mb-5">
                <span className="Sync_Status_label_class">
                  {" "}
                  {SynckCheck == 0 ? (
                    <i class="fa fa-circle red_circle_for_sync"></i>
                  ) : (
                    <i class="fa fa-circle green_circle_for_sync"></i>
                  )}{" "}
                  {SynckCheck == 0
                    ? "Sync Fail"
                    : "Sync Success"}
                </span>
              </Link>

          {/* Receiving Receipt */}
          <div id="print" className="receipt-card-body">
            <div className="card-body">
              {/* Header */}
              <div id="header">
                <div>
                  <div className="row">
                    <div className="col-md-6" style={{ marginLeft: "20px" }}>
                      <p
                        className="fw-bold"
                        style={{ fontFamily: "Inter, sans-serif" , fontSize:"20px" , color:"black"}}
                      >
                        {companyData[0]?.CompanyName}
                      </p>{" "}
                      {/* <br /> */}
                      <p style={{ fontFamily: "Inter, sans-serif" , fontSize:"20px" ,color:"black"}}>
                        {companyData[0]?.CompanyAddress}
                      </p>
                      {/* <br /> */}
                      <p style={{ fontFamily: "Inter, sans-serif",color:"black" }}>
                        {companyData[0]?.Website}
                      </p>
                    </div>
                    {/* <div className="col-md-1"> </div> */}
                    <div className="col-md-4">
                      <div
                        className="fw-bold"
                        style={{
                          fontFamily: "Inter, sans-serif",
                          fontSize: "15px",color:"black"
                        }}
                      >
                        {/* {receive[0]?.ReceivingsType} */}
                      </div>

                      <div
                        className="fw-bold"
                        style={{ fontFamily: "Inter, sans-serif" , fontSize:"18px",color:"black" }}
                      >
                        {/* # RECV-{receive[0]?.ID} */}
                        {/* # RECV-
                        {receive[0]?.Posid} */}
                        RECEIVING ID : #{receive[0]?.Posid}

{/* {`# ${receive[0]?.ReceivingsType}`}
 - {receive[0]?.Posid} */}


                        

                        {/* {receive[0]?.ReceivingsType == "Expense" ? `# EXPE -` : "# RECV -"}  {receive[0]?.Posid} */}

                      </div>

                   <div className="d-flex">
                   {/* <div
                        className="fw-bold"
                        style={{
                          fontFamily: "Inter, sans-serif",color:"black"
                        }}
                      >
                        Balance Due : {" "}
                      </div>
                      <div
                        className="fw-bold"
                        style={{
                          fontFamily: "Inter, sans-serif",
                          fontSize: "12px",
                        }}
                      >
                       {' '} $ {Number(receive[0]?.Total).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </div> */}
                   </div>
                   <div className="d-flex">
                   <div
                        className="fw-bold"
                        style={{
                          fontFamily: "Inter, sans-serif",color:"black"
                        }}
                      >
                        Ref No : {" "}
                      </div>
                      <div
                        className="fw-bold"
                        style={{
                          fontFamily: "Inter, sans-serif",
                          fontSize: "12px",color:"black"
                        }}
                      >
                       {' '}{Number(receive[0]?.BillNo)}
                      </div>
                   </div>
                    </div>
                  </div>
                  <hr></hr>
                  <div className="row">
                    <div className="col-md-5" style={{ marginLeft: "20px" ,color:"black"}}>
                      {/* <br /> <br /> */}
                      <div>
                      
                        {supplierData?.map((item, index) => {
                          console.log(item , "check item")
                          return (
                            <>
                              <p
                               
                                style={{ fontFamily: "Inter, sans-serif", color:"black" }}
                              >
                               Bill From : 
                               {/* <span style={{color:"black"}} className="fw-bold mt-1"> {item?.SupplierId} - {item.Name ==  ' ' || null  ? item.CompanyName : item.Name}</span> */}
                              </p>
                              {/* <br /> */}
                              <p style={{ fontFamily: "Inter, sans-serif" , color:"black"}}>
                                Company Name : <b style={{color:"black"}}>
                                  {/* {item.CompanyName} */}
                                  {item?.SupplierId} - {item.Name ==  ' ' || null  ? item.CompanyName : item.Name}
                                  </b>
                              </p>
                              {/* <br /> */}
                              <p style={{ fontFamily: "Inter, sans-serif", color:"black" }}>
                                Address :  
                                {/* {item?.Address} , {item.Address && (item.Zip == "" || item.Zip == null) ? "" : `${item?.Country}, ${item?.Zip}`} */}
                                {/* {item?.Address && `${item.Address},`}{item?.Address2 &&`${item.Address2},`}{item?.City && `${item.City},`}{item?.State && `${item.State} `}{(item?.Zip && item.Zip !== "" && item.Zip !== null) && `${item.Zip} `},{item?.Country && `${item.Country}`} */}
                                {item?.Address && `${item.Address}, `}
{item?.Address2 && `${item.Address2}, `}
{item?.City && `${item.City}, `}
{item?.State && `${item.State} `}
{(item?.Zip && item.Zip !== "" && item.Zip !== null) && `${item.Zip}, `}
{item?.Country && `${item.Country}`}

                              </p>
                              {/* <br /> */}
                              {/* <p style={{ fontFamily: "Inter, sans-serif" , color:"black"}}>
                                Country: 
                              </p> */}
                              {/* <br /> */}
                              {/* <p style={{ fontFamily: "Inter, sans-serif" , color:"black"}}>
                                Pincode : {item.Zip}
                              </p> */}
                            </>
                          );
                        })}
                      </div>
                      <p style={{ fontFamily: "Inter, sans-serif" , color:"black"}}>
                        ShipVia:{receive[0]?.ShipVia}
                      </p>{" "}
                    </div>
                    <div
                      className="col-md-6"
                      style={{
                        //marginLeft: "49px",
                        textAlign: "right",
                      }}
                    >
                      <div className="row">
                        <div>
                          <div>
                            <div
                              style={
                                {
                                  // borderBottom: "1px solid #E8EBED",
                                }
                              }
                            >
                              <div
                                style={{
                                  marginLeft: "20px",
                                }}
                              >
                                <div className="row">
                                  <div
                                    style={{ fontFamily: "Inter, sans-serif" , color:"black"}}
                                    className="col-md-12"
                                  >
                                    Receiving Date:{" "}
                                    {receive[0]?.ReceivingDate}
                                  </div>
                                </div>
                                {/* <hr /> */}
                                <div className="row">
                                  <div
                                    style={{ fontFamily: "Inter, sans-serif", color:"black" }}
                                    className="col-md-12"
                                  >
                                    Type:{" "}
                                    {" " + receive[0]?.ReceivingsType &&  
                                      receive[0]?.ReceivingsType}
                                  </div>
                                </div>
                                {/* <hr /> */}
                                <div className="row">
                                  <div
                                    style={{ fontFamily: "Inter, sans-serif" , color:"black"}}
                                    className="col-md-12"
                                  >
                                    Due Date:{" "}
                                    {receive[0]?.DueDate}
                                  </div>
                                </div>
                              </div>

                              <div className="row">
                                <div
                                  style={{
                                    fontFamily: "Inter, sans-serif", color:"black"
                                  }}
                                  className="col-md-12"
                                >
                             

                                   CreatedDate:{" "}
                                  {/* {receive && " " + moment(receive[0]?.CreatedDate).format("MM/DD/YYYY HH:mm:ss")} */}
                                  {receive && receive[0]?.CreatedDate ? " " + moment(receive[0].CreatedDate).format("MM/DD/YYYY HH:mm:ss") : ""}
                                </div>
                                <div
                                  style={{
                                    fontFamily: "Inter, sans-serif", color:"black"
                                  }}
                                  className="col-md-12"
                                >
                                  Created by :
                                  {receive && " " + receive[0]?.CreatedName}
                                </div>
                                <div
                                  style={{
                                    fontFamily: "Inter, sans-serif", color:"black"
                                  }}
                                  className="col-md-12"
                                >
                                   ModifiedDate:{" "}
                                  {/* {receive && " " +  moment(receive[0]?.ModifiedDate).format( "MM/DD/YYYY HH:mm:ss")} */}
                                  {receive && receive[0]?.ModifiedDate ? " " + moment(receive[0].ModifiedDate).format("MM/DD/YYYY HH:mm:ss") : ""}

                                </div>
                                <div
                                  style={{
                                    fontFamily: "Inter, sans-serif", color:"black"
                                  }}
                                  className="col-md-12"
                                >
                                   Modified By:{" "}
                                  {(receive[0]?.ModifideName ) == "" || null ? "" : (receive[0]?.ModifideName)}
                                </div>

                               
                              </div>

                              <div className="row">
                               
                              </div>

                              <div className="row">
                                <p
                                  id="page-no"
                                  style={{
                                    fontFamily: "Inter, sans-serif",
                                    display: "none",
                                     color:"black"
                                  }}
                                >
                                  {/* {currentPage} */}
                                  Page NO : {currentPage}/{totalPages}
                                </p>
                              </div>
                              {/* <div
                              
                              style={{
                                paddingBottom: "0.5rem",
                                paddingTop: "0.5rem",
                              }}
                            > */}
                              {/* <div >
                                {supplierData?.map((item, index) => {
                                  return (
                                    <>
                                      <p style={{ marginBottom: "5px" }}>
                                        Contact Number: {item.PhoneNumber}
                                      </p>
                                    </>
                                  );
                                })}
                              </div> */}
                              {/* </div> */}
                            </div>
                            {/* <hr /> */}

                            {/* <hr /> */}

                            {/* <div
                              className="row"
                              style={{
                                paddingTop: "0.5rem",
                              }}
                            ></div> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <hr />
                {/* <div className="d-flex justify-content-between">  
                  <p
                    style={{
                      fontWeight: "bold",
                      fontFamily: "Inter, sans-serif",
                    }}
                  >
                    Receive Date :{" "}
                    {moment(receive[0]?.ReceivingDate).format("MM/DD/YYYY")}
                  </p>
                  <p
                    style={{
                      fontWeight: "bold",
                      fontFamily: "Inter, sans-serif",
                    }}
                  >
                    Currency : $
                  </p>
                </div> */}
              </div>

              <div style={{display  :"none"}}>
              <div id="header1">
                <div>
                  <div className="row">
                    <div className="col-md-6" style={{ marginLeft: "20px" }}>
                      <p
                        className="fw-bold"
                        style={{ fontFamily: "Inter, sans-serif" , fontSize:"20px"}}
                      >
                        {companyData[0]?.CompanyName}
                      </p>{" "}
                      {/* <br /> */}
                      <p style={{ fontFamily: "Inter, sans-serif" , fontSize:"20px" }}>
                        {companyData[0]?.CompanyAddress}
                      </p>
                      {/* <br /> */}
                      <p style={{ fontFamily: "Inter, sans-serif" }}>
                        {companyData[0]?.Website}
                      </p>
                    </div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-3">
                      <div
                        className="fw-bold"
                        style={{
                          fontFamily: "Inter, sans-serif",
                          fontSize: "15px",
                        }}
                      >
                        {receive[0]?.ReceivingsType}
                      </div>

                      <div
                        className="fw-bold"
                        style={{ fontFamily: "Inter, sans-serif" , fontSize:"18px" }}
                      >
                        {/* # RECV-{receive[0]?.ID} */}
                        {/* # RECV-
                        {receive[0]?.Posid} */}

                        {receive[0]?.ReceivingsType == "Expense" ? `# EXPE -` : "# RECV -"}  {receive[0]?.Posid}

                      </div>

                   <div className="d-flex">
                   {/* <div
                        className="fw-bold"
                        style={{
                          fontFamily: "Inter, sans-serif",
                        }}
                      >
                        Balance Due : {" "}
                      </div>
                      <div
                        className="fw-bold"
                        style={{
                          fontFamily: "Inter, sans-serif",
                          fontSize: "12px",
                        }}
                      >
                       {' '} $ {Number(receive[0]?.Total).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </div> */}
                   </div>
                   <div className="d-flex">
                   <div
                        className="fw-bold"
                        style={{
                          fontFamily: "Inter, sans-serif",
                        }}
                      >
                        Ref No : {" "}
                      </div>
                      <div
                        className="fw-bold"
                        style={{
                          fontFamily: "Inter, sans-serif",
                          fontSize: "12px",
                        }}
                      >
                       {' '}{Number(receive[0]?.BillNo)}
                      </div>
                   </div>
                    </div>
                  </div>
                 
                        
                        </div>
                      </div>
              </div>

              {/* Body */}
              <div className="table-responsive" id="body">
                {receive[0]?.ReceivingTypeId === 5 ||
                receive[0]?.ReceivingTypeId === 7 ? (
                  <table className="table mt-1">
                    <thead>
                      <tr>
                        <th className="col-md-1">S.No</th>
                        <th className="col-md-3">Chart of Account</th>
                        <th className="col-md-3">Description</th>
                        {/* <th
                          className="col-md-2"
                          style={{ textAlign: "center" }}
                        >
                          Barcode
                        </th>
                        <th className="col-md-2" style={{ textAlign: "right" }}>
                          Price
                        </th>
                        <th className="col-md-2" style={{ textAlign: "right" }}>
                          Quantity
                        </th>
                        <th className="col-md-2" style={{ textAlign: "right" }}>
                          Discount %
                        </th> */}
                        {/* <th className="col-md-2" style={{ textAlign: "right" }}>
                        Tax %
                      </th> */}
                        <th className="col-md-2" style={{ textAlign: "right" }}>
                          Amount
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {responseData?.map((item, index) => {
                        console.log("responseDataaff", responseData);
                        const individualTotal =
                          parseFloat(item.QuantityReceived) *
                          parseFloat(item.ItemCostPrice);

                        return (
                          <>
                            <tr>
                              <td className="col-md">{++index}</td>
                              {/* <td style={{ textAlign: "left", borderBottom:"0px", padding: "5px" "10px"; }} colSpan={6}> */}
                              {/* <td className="col-md-2" */}

                              {/* > */}
                              {/* <strong>{item.Items}</strong> */}
                              {/* <small className="d-flex justify-content-start align-items-center">
                              <span className="mr-2">Item Number:</span>
                              <span className="flex-fill text-center fw-bold">
                                {item.ItemNumber}
                              </span>
                            </small> */}
                              {/* </td> */}
                              <td
                                style={{ textAlign: "left" }}
                                className="col-md-2"
                              >
                                {/* {++index}
                            &nbsp; &nbsp; &nbsp;
                            <strong>{item.Items}</strong>
                            */}
                                <small className="col-md-2">
                                  {/* <strong>Item Name: </strong> */}
                                  <strong>
                                    {" " + item?.ItemvariationId > 0
                                      ? item.ItemVariationName
                                      : item?.ItemName}
                                  </strong>
                                </small>
                                {/* <p>
                                  Item Number:
                                  {" " + item.Itemnumber}
                                </p> */}
                              </td>
                              <td className="col-md-2">{item.Description} </td>
                              {/* <td
                                className="col-md-2"
                                style={{ textAlign: "right" }}
                              >
                                {Number(item.ItemCostPrice).toFixed(2)}
                              </td>
                              <td
                                className="col-md-2"
                                style={{ textAlign: "right" }}
                              >
                                {Number(item.QuantityReceived).toFixed(2)}
                              </td>
                              <td
                                className="col-md-2"
                                style={{ textAlign: "right" }}
                              >
                                {Number(item.DiscountPercent).toFixed(2)}
                              </td> */}
                              {/* <td
                              className="col-md-2"
                              style={{ textAlign: "right" }}
                            >

                              {Number(item.Tax).toFixed(2)}
                            </td> */}
                              <td
                                className="col-md-2"
                                style={{ textAlign: "right" }}
                              >
                                {Number(item.Total).toFixed(2)}
                              </td>
                            </tr>
                          </>
                        );
                      })}
                    </tbody>
                  </table>
                ) : (
                  <table className="table mt-1">
                    <thead>
                      <tr>
                        <th className="col-md">S.No</th>
                        <th className="col-md-3">Description</th>
                        {/* <th
                          className="col-md-2"
                          style={{ textAlign: "center" }}
                        >
                          Barcode
                        </th> */}
                        <th className="col-md-2" style={{ textAlign: "right" }}>
                          Price
                        </th>
                        <th className="col-md-2" style={{ textAlign: "right" }}>
                          Quantity
                        </th>
                        <th className="col-md-2" style={{ textAlign: "right" }}>
                          Discount %
                        </th>
                        {/* <th className="col-md-2" style={{ textAlign: "right" }}>
                        Tax %
                      </th> */}
                        <th className="col-md-2" style={{ textAlign: "right" }}>
                          Total
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                    <>
    {/* Show the first item where Module = 'item' */}
    {responseData
      .filter(item => item.Module === 'Item')
      .map((item, index) => {
        const individualTotal =
          parseFloat(item.QuantityReceived) * parseFloat(item.ItemCostPrice);

        return (
          <tr key={item.ID}>
            <td className="col-md">{++index}</td>
            <td style={{ textAlign: "left" }} className="col-md-2">
              <small className="col-md-2">
                <strong>
                  {item?.ItemvariationId > 0
                    ? item.ItemVariationName
                    : item?.ItemName}
                </strong>
              </small>
              <p>Item Number: {item.Itemnumber}</p>
            </td>
            <td className="col-md-2" style={{ textAlign: "right" }}>
              {Number(item.ItemCostPrice).toFixed(2)}
            </td>
            <td className="col-md-2" style={{ textAlign: "right" }}>
              {Number(item.QuantityReceived).toFixed(2)}
            </td>
            <td className="col-md-2" style={{ textAlign: "right" }}>
              {Number(item.DiscountPercent).toFixed(2)}
            </td>
            <td className="col-md-2" style={{ textAlign: "right" }}>
              {Number(item.Total).toFixed(2)}
            </td>
          </tr>
        );
      })}

    {/* Show all items where Module = 'Accounts' */}
    {responseData
      .filter(item => item.Module === 'Accounts')
      .map((item, index) => {
        const individualTotal =
          parseFloat(item.QuantityReceived) * parseFloat(item.ItemCostPrice);

        return (
          <tr key={item.ID}>
            <td className="col-md"></td>
            {/* <td className="col-md">{++index}</td> */}
            <td style={{ textAlign: "left" }} className="col-md-2">
              <small className="col-md-2">
                <strong>
                  {item?.ItemvariationId > 0
                    ? item.ItemVariationName
                    : item?.ItemName}
                </strong>
              </small>
              {/* <p>Item Number: {item.Itemnumber}</p> */}
            </td>
            <td className="col-md-2" style={{ textAlign: "right" }}>
              {Number(item.ItemCostPrice).toFixed(2)}
            </td>
            <td className="col-md-2" style={{ textAlign: "right" }}>
              {Number(item.QuantityReceived).toFixed(2)}
            </td>
            <td className="col-md-2" style={{ textAlign: "right" }}>
              {Number(item.DiscountPercent).toFixed(2)}
            </td>
            <td className="col-md-2" style={{ textAlign: "right" }}>
              {Number(item.Total).toFixed(2)}
            </td>
          </tr>
        );
      })}
  </>
                    </tbody>
                  </table>
                )}

                <div style={{ textAlign: "right" }} className="mt-3">
                  <p style={{ margin: "0" }}>
                    <strong>Sub Total: </strong>$
                    {Number(receive[0]?.Subtotal).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  </p>
                  <p style={{ margin: "0" }}>
                    <strong>Discount : </strong>$
                    {Number(receive[0]?.DiscountEntireSale).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  </p>
                  <p style={{ margin: "0" }}>
                    <strong>Total Amount: </strong>$
                    {Number(receive[0]?.Total).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  </p>
                </div>
                <hr />
              </div>

              {/* Footer */}
              <div style={{ display: "none" }}>
                <div id="Totalfooter">
                  <div className="row">
                    <div className="col-md-6">
                      <p style={{ margin: "0" }}>
                        <strong>Comment: </strong>
                        {receive[0]?.Comment}
                      </p>
                    </div>

                    <div
                      style={{ textAlign: "right" }}
                      className="mt-3 col-md-6"
                    >
                      <p style={{ margin: "0" }}>
                        <strong>Sub Total: </strong>${" "}
                        {Number(receive[0]?.Subtotal).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </p>
                      <p style={{ margin: "0" }}>
                        <strong>Total item : </strong>
                        {Number(responseData.length).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </p>
                      <p style={{ margin: "0" }}>
                        <strong>Total Qty : </strong>
                        {Number(sumss).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </p>

                      <p style={{ margin: "0" }}>
                        <strong>Total Amount: </strong>$
                        {Number(receive[0]?.Total).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </p>
                    </div>
                  </div>
                </div>

                <div id="footer">
                  <div className="row">
                    <p
                      style={{
                        marginTop: "20px",
                        textAlign: "center",
                        fontSize: "10px",
                      }}
                    >
                      BY SIGNING AND ACCEPTING THE ORDER CUSTOMER AGREES THAT
                      THE INFORMATION ABOVE IS TRUE & THEREFORE IS RESPONSIBLE
                      FOR THE ENTIRE BALANCE ON THE INVOICE. ALL CREDIT MUST BE
                      APPROVED BY THE OFFICE. NO RETURNS ACCEPTED. NO
                      RETURN/EXCHANGE ON ANY ELECTRONIC CIGARETTES OR VAPE ITEMS
                      NO EXCEPTIONS. OVER 5000+ CONVENIENCE STORE ITEMS GENERAL
                      MERCHANDISE. QUICK DELIVERY..LOW PRICES. THERE IS $35 BANK
                      FEE FOR ALL RETURNED CHECKS. CUSTOMER IS RESPONSIBLE FOR
                      ALL STATE AND LOCAL TAXES. SALE OF FLAVORED VAPES NOT
                      ALLOWED IN CERTAIN STATES, CUSTOMER IS RESPONSIBLE FOR ALL
                      STATE AND LOCAL COMPLIANCE RULES AND REGULATIONS.{" "}
                    </p>

                    <div
                        className="d-flex"
                        style={{
                          position: "relative",
                          justifyContent: "space-between",
                          padding: "20px",
                          color:'black',
                         
                        }}
                      >
                        <div style={{ gap: "50px" }}>
                          <p style={{ marginTop: "30px" }}>
                            {" "}
                            Customer Signature: ______________________{" "}
                          </p>
                          <p style={{ marginTop: "25px" }}>
                            {" "}
                            Date: _____________________{" "}
                          </p>
                        </div>

                        {/* Second div aligned to the right and placed inside a box */}
                        <div
                          style={{
                            border: "1px solid black",
                            padding: "10px",
                            width: "300px",
                            position: "absolute",
                            right: "0",
                            top: "40px",
                            color:'black',
                             marginRight:"50px"
                          }}
                        >
                          <p style={{ marginTop: "10px" }}>
                            {" "}
                            PREPARED BY: _________________________{" "}
                          </p>
                          <p style={{ marginTop: "20px" }}>
                            {" "}
                            CHECKED BY: __________________________{" "}
                          </p>
                        </div>
                      </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div>
                {SynckCheck == 0 ? (
                  <Link
                    className="btn btn-sm btn-secondary me-1 mt-5"
                  >
                    {`${
                      SynckMassageCheck
                    }`}
                  </Link>
                ) : (
                  ""
                )}
              </div>
        </div>
      </div>
      <div style={{ display: "none" }}>
        {responseData?.map((item) => (
          <>
            <div key={item.ReceivingId}>
              <canvas
                data-name={item.ReceivingId}
                ref={(el) => (barcodeRefs.current[item.ReceivingId] = el)}
                id={`barcode-${item.ReceivingId}`}
              />
            </div>
          </>
        ))}
      </div>
    </>
  );
};

export default ReceivingReceipt;